import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut } from "lucide-react";

function BrandMark({ className = "w-6 h-6" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
      <path d="M 32 54 C 32 42, 30 34, 25 26" stroke="#4A5D4E" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      <path d="M 32 46 C 37 46, 40 43, 40 38 C 36 38, 32 41, 32 46 Z" fill="#4A5D4E" />
      <path d="M 30 38 C 25 38, 22 35, 22 30 C 26 30, 30 33, 30 38 Z" fill="#4A5D4E" />
      <path d="M 28 30 C 33 30, 36 27, 36 22 C 32 22, 28 25, 28 30 Z" fill="#4A5D4E" />
      <path d="M 25 26 C 25 21, 28 18, 32 18 C 32 22, 29 26, 25 26 Z" fill="#C27A62" />
    </svg>
  );
}

export default function Navbar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <header
      className="no-print sticky top-0 z-30 backdrop-blur-md"
      style={{ background: "rgba(253,251,247,0.85)", borderBottom: "1px solid var(--border)" }}
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="nav-logo">
          <BrandMark className="w-6 h-6" />
          <span
            className="font-serif text-xl lowercase"
            style={{ color: "var(--text)", letterSpacing: "0.18em", fontWeight: 400 }}
          >
            alternavit
          </span>
        </Link>

        <nav className="flex items-center gap-2 sm:gap-4">
          {user ? (
            <>
              <NavLink
                to="/questionnaire"
                className="hidden sm:inline text-sm hover:underline"
                style={{ color: "var(--text-2)" }}
                data-testid="nav-questionnaire"
              >
                New Assessment
              </NavLink>
              <NavLink
                to="/dashboard"
                className="hidden sm:inline text-sm hover:underline"
                style={{ color: "var(--text-2)" }}
                data-testid="nav-dashboard"
              >
                History
              </NavLink>
              <NavLink
                to="/tracker"
                className="hidden sm:inline text-sm hover:underline"
                style={{ color: "var(--text-2)" }}
                data-testid="nav-tracker"
              >
                Tracker
              </NavLink>
              <NavLink
                to="/settings"
                className="hidden md:inline text-sm hover:underline"
                style={{ color: "var(--text-2)" }}
                data-testid="nav-settings"
              >
                Settings
              </NavLink>
              <span className="hidden md:inline text-sm" style={{ color: "var(--text-2)" }}>
                {user.name}
              </span>
              <button
                onClick={() => {
                  logout();
                  nav("/");
                }}
                className="btn-ghost text-sm flex items-center gap-1.5"
                data-testid="nav-logout"
              >
                <LogOut className="w-4 h-4" strokeWidth={1.5} />
                <span className="hidden sm:inline">Sign out</span>
              </button>
            </>
          ) : (
            <>
              <Link to="/auth" className="text-sm hover:underline" style={{ color: "var(--text-2)" }} data-testid="nav-login">
                Sign in
              </Link>
              <Link to="/auth?mode=register" className="btn-primary text-sm" data-testid="nav-get-started">
                Get started
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
